function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
// Component for the advanced params input field.
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var Options = /*#__PURE__*/function (_Component) {
  function Options(props) {
    var _this;
    _classCallCheck(this, Options);
    _this = _callSuper(this, Options, [props]);
    _this.state = {
      textValue: '',
      objectValue: _this.defaultObjectValue(),
      paramsMode: 'advanced'
    };
    _this.onTextValueChanged = _this.onTextValueChanged.bind(_this);
    _this.optionsPresetsJSX = _this.optionsPresetsJSX.bind(_this);
    _this.advancedParamsJSX = _this.advancedParamsJSX.bind(_this);
    _this.showAdvancedOptionsHelp = _this.showAdvancedOptionsHelp.bind(_this);
    return _this;
  }
  _inherits(Options, _Component);
  return _createClass(Options, [{
    key: "defaultObjectValue",
    value: function defaultObjectValue() {
      return {
        max_target_seqs: '',
        evalue: '',
        task: ''
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.predefinedOptions !== this.props.predefinedOptions) {
        var defaultOptions = this.props.predefinedOptions["default"] || {
          attributes: []
        };
        var advancedOptions = this.props.predefinedOptions['last search'] || defaultOptions || {
          attributes: []
        };
        var initialTextValue = advancedOptions.attributes.join(' ').trim();
        var parsedOptions = this.parsedOptions(initialTextValue);
        this.setState({
          textValue: initialTextValue,
          objectValue: parsedOptions
        });
      }
    }
  }, {
    key: "onTextValueChanged",
    value: function onTextValueChanged(textValue) {
      var parsedOptions = this.parsedOptions(textValue.toString());
      this.setState({
        textValue: textValue.toString(),
        objectValue: parsedOptions
      });
    }
  }, {
    key: "parsedOptions",
    value: function parsedOptions(textValue) {
      var words = textValue.split(" ");
      var parsedOptions = this.defaultObjectValue();
      // Iterate through the words in steps of 2, treating each pair as an option and its potential value
      for (var i = 0; i < words.length; i += 2) {
        // Ensure there is a pair available
        if (words[i]) {
          if (words[i].startsWith("-")) {
            var optionName = words[i].substring(1).trim();
            if (words[i + 1]) {
              // Use the second word as the value for this option
              parsedOptions[optionName] = words[i + 1];
            } else {
              // No value found for this option, set it to null or a default value
              parsedOptions[optionName] = null;
            }
          }
        }
      }
      return parsedOptions;
    }
  }, {
    key: "optionsPresetsJSX",
    value: function optionsPresetsJSX() {
      return /*#__PURE__*/_jsx("div", {
        id: "options-presets",
        className: "w-full",
        children: Object.keys(this.props.predefinedOptions).length > 1 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center border-b border-seqorange mb-2",
            children: [/*#__PURE__*/_jsx("h3", {
              className: "text-base md:text-lg font-medium pr-1",
              children: "Settings"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-base text-gray-500",
              children: "Choose a predefined setting or customize parameters."
            })]
          }), this.presetListJSX()]
        })
      });
    }
  }, {
    key: "presetListJSX",
    value: function presetListJSX() {
      var _this2 = this;
      return /*#__PURE__*/_jsx("ul", {
        className: "md:text-lg my-1",
        children: Object.entries(this.props.predefinedOptions).map(function (_ref, index) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            config = _ref2[1];
          var textValue = config.attributes.join(' ').trim();
          var description = config.description || textValue;
          return /*#__PURE__*/_jsxs("label", {
            className: "block w-full px-2 py-1 text-seqblue hover:bg-gray-200 hover:text-seqorange cursor-pointer",
            children: [/*#__PURE__*/_jsx("input", {
              type: "radio",
              name: "predefinedOption",
              value: textValue,
              checked: textValue === _this2.state.textValue,
              onChange: function onChange() {
                return _this2.onTextValueChanged(textValue);
              }
            }), /*#__PURE__*/_jsxs("strong", {
              className: "ml-2",
              children: [key, ":"]
            }), "\xA0", description]
          }, index);
        })
      });
    }
  }, {
    key: "advancedParamsJSX",
    value: function advancedParamsJSX() {
      var _this3 = this;
      var classNames = 'flex-grow block px-4 py-1 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-base font-mono';
      if (this.state.textValue) {
        classNames += ' bg-yellow-100';
      }
      return /*#__PURE__*/_jsxs("div", {
        className: this.state.paramsMode !== 'advanced' ? 'w-full hidden' : 'w-full',
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-end",
          children: [/*#__PURE__*/_jsx("label", {
            className: "flex items-center text-base md:text-lg",
            htmlFor: "advanced",
            children: "Parameters:"
          }), this.props.blastMethod && /*#__PURE__*/_jsxs("button", {
            className: "text-seqblue text-base md:text-lg ml-2",
            type: "button",
            onClick: this.showAdvancedOptionsHelp,
            "data-toggle": "modal",
            "data-target": "#help",
            children: ["See options", /*#__PURE__*/_jsx("i", {
              className: "fa fa-question-circle ml-1 w-3 h-4 fill-current"
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-grow flex w-full",
          children: /*#__PURE__*/_jsx("input", {
            type: "text",
            className: classNames,
            onChange: function onChange(e) {
              return _this3.onTextValueChanged(e.target.value);
            },
            id: "advanced",
            name: "advanced",
            value: this.state.textValue,
            placeholder: "eg: -evalue 1.0e-5 -num_alignments 100",
            title: "View, and enter advanced parameters."
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-1 text-gray-700",
          children: "Options as they would appear in a command-line."
        })]
      });
    }
  }, {
    key: "showAdvancedOptionsHelp",
    value: function showAdvancedOptionsHelp(e) {
      var ids = ['blastn', 'tblastn', 'blastp', 'blastx', 'tblastx'];
      var method = this.props.blastMethod.toLowerCase();
      var modal = document.querySelector("dialog.advanced-modal");

      // hide options for other algorithms and only show for selected algorithm
      for (var _i = 0, _ids = ids; _i < _ids.length; _i++) {
        var id = _ids[_i];
        if (id === method) {
          document.getElementById(id).classList.remove('hidden');
        } else {
          document.getElementById(id).classList.add('hidden');
        }
      }
      modal.showModal();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        className: "flex-grow flex flex-col items-start sm:items-center space-y-4",
        children: [this.optionsPresetsJSX(), this.advancedParamsJSX()]
      });
    }
  }]);
}(Component);